import { type Context, createContext } from 'react';

// Only the async entry point can own loading across both the assistant and UI bundles.
export const ConversationAssistantLoadingContext: Context<boolean> = createContext(false);
